import { render, staticRenderFns } from "./ComboTrueFalse.vue?vue&type=template&id=1add107d"
import script from "./ComboTrueFalse.vue?vue&type=script&lang=js"
export * from "./ComboTrueFalse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports